/* ==========================================================================
   Luvandra — interacciones propias. Vanilla, sin librerías.
   Cada init comprueba si su elemento existe, así el archivo sirve en todas
   las páginas.
   ========================================================================== */
(function () {
  "use strict";

  var sinMovimiento =
    window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* Este archivo lo carga CADA sección, así que se ejecuta varias veces en la
     misma página. Sin esto, cada elemento acabaría con un manejador por copia
     y un solo clic contaría varias veces (el botón "+" sumaba de 15 en 15).
     `nuevos()` devuelve solo los elementos que aún no se han preparado. */
  function nuevos(selector, clave) {
    var lista = [];
    Array.prototype.forEach.call(document.querySelectorAll(selector), function (el) {
      if (el.dataset[clave]) return;
      el.dataset[clave] = "1";
      lista.push(el);
    });
    return lista;
  }

  /* ---------- Reveals al hacer scroll (un solo observer) ---------- */
  function initReveals() {
    var elementos = nuevos(".lv-reveal, .lv-mask", "lvIniRev");
    if (!elementos.length) return;
    if (sinMovimiento || !("IntersectionObserver" in window)) {
      elementos.forEach(function (el) { el.classList.add("lv-visible"); });
      return;
    }
    var obs = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add("lv-visible");
            obs.unobserve(e.target);
          }
        });
      },
      { rootMargin: "0px 0px -8% 0px", threshold: 0.08 }
    );
    elementos.forEach(function (el) { obs.observe(el); });

    /* Red de seguridad: si por lo que sea el navegador no dispara el observador
       (pestaña abierta en segundo plano, motor sin soporte real, etc.) el
       contenido se quedaría invisible. Pasado un momento, se muestra todo lo
       que ya está en pantalla; y si NADA se ha mostrado, se muestra todo. */
    function rescatar() {
      var alguno = document.querySelector(".lv-visible");
      var alto = window.innerHeight || 800;
      elementos.forEach(function (el) {
        if (el.classList.contains("lv-visible")) return;
        var caja = el.getBoundingClientRect();
        if (!alguno || caja.top < alto * 1.2) {
          el.classList.add("lv-visible");
          obs.unobserve(el);
        }
      });
    }
    setTimeout(rescatar, 1400);
    document.addEventListener("visibilitychange", function () {
      if (!document.hidden) setTimeout(rescatar, 200);
    });
  }

  /* ---------- Parallax suave (solo transform) ---------- */
  function initParallax() {
    var capas = nuevos("[data-lv-parallax]", "lvIniPar");
    if (!capas.length || sinMovimiento) return;
    var tic = false;
    function pintar() {
      var vh = window.innerHeight;
      capas.forEach(function (c) {
        var r = c.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        var fuerza = parseFloat(c.getAttribute("data-lv-parallax")) || 10;
        var centro = r.top + r.height / 2 - vh / 2;
        c.style.transform = "translate3d(0," + (-centro / vh) * fuerza + "px,0)";
      });
      tic = false;
    }
    window.addEventListener(
      "scroll",
      function () {
        if (!tic) { window.requestAnimationFrame(pintar); tic = true; }
      },
      { passive: true }
    );
    pintar();
  }

  /* ---------- Comparador antes / después ---------- */
  function initComparador() {
    nuevos("[data-lv-comp]", "lvIniCmp").forEach(function (comp) {
      var arrastrando = false;
      function mover(x) {
        var r = comp.getBoundingClientRect();
        var p = ((x - r.left) / r.width) * 100;
        p = Math.max(2, Math.min(98, p));
        comp.style.setProperty("--lv-pos", p + "%");
      }
      comp.addEventListener("pointerdown", function (e) {
        arrastrando = true;
        comp.setPointerCapture(e.pointerId);
        mover(e.clientX);
      });
      comp.addEventListener("pointermove", function (e) {
        if (arrastrando) mover(e.clientX);
      });
      ["pointerup", "pointercancel"].forEach(function (ev) {
        comp.addEventListener(ev, function () { arrastrando = false; });
      });
      comp.addEventListener("keydown", function (e) {
        var actual = parseFloat(comp.style.getPropertyValue("--lv-pos")) || 50;
        if (e.key === "ArrowLeft") { comp.style.setProperty("--lv-pos", Math.max(2, actual - 4) + "%"); e.preventDefault(); }
        if (e.key === "ArrowRight") { comp.style.setProperty("--lv-pos", Math.min(98, actual + 4) + "%"); e.preventDefault(); }
      });
      /* Pequeña demostración al entrar en pantalla */
      if (!sinMovimiento && "IntersectionObserver" in window) {
        var demo = new IntersectionObserver(function (en) {
          en.forEach(function (e) {
            if (!e.isIntersecting) return;
            demo.unobserve(e.target);
            var ini = 50, fin = 74, t0 = null;
            function paso(t) {
              if (!t0) t0 = t;
              var k = Math.min(1, (t - t0) / 1100);
              var s = 1 - Math.pow(1 - k, 3);
              comp.style.setProperty("--lv-pos", (ini + (fin - ini) * s) + "%");
              if (k < 1) requestAnimationFrame(paso);
            }
            setTimeout(function () { requestAnimationFrame(paso); }, 420);
          });
        }, { threshold: 0.4 });
        demo.observe(comp);
      }
    });
  }

  /* ---------- Escena sticky: el visual cambia con los pasos ---------- */
  function initSticky() {
    nuevos("[data-lv-sticky]", "lvIniEsc").forEach(function (escena) {
      var pasos = escena.querySelectorAll(".lv-sticky__paso");
      var imgs = escena.querySelectorAll(".lv-sticky__marco img");
      if (!pasos.length || !imgs.length) return;
      function activar(i) {
        pasos.forEach(function (p, k) { p.classList.toggle("lv-on", k === i); });
        imgs.forEach(function (im, k) { im.classList.toggle("lv-on", k === i); });
      }
      activar(0);
      if (!("IntersectionObserver" in window)) { pasos.forEach(function (p) { p.classList.add("lv-on"); }); return; }
      var obs = new IntersectionObserver(
        function (entradas) {
          entradas.forEach(function (e) {
            if (e.isIntersecting) activar(parseInt(e.target.getAttribute("data-i"), 10) || 0);
          });
        },
        { rootMargin: "-46% 0px -46% 0px", threshold: 0 }
      );
      pasos.forEach(function (p) { obs.observe(p); });
    });
  }

  /* ---------- Acordeón ---------- */
  function initAcordeon() {
    nuevos("[data-lv-acc]", "lvIniAcc").forEach(function (acc) {
      var unico = acc.getAttribute("data-lv-acc") === "unico";
      acc.querySelectorAll(".lv-acc__btn").forEach(function (btn) {
        btn.addEventListener("click", function () {
          var item = btn.closest(".lv-acc__item");
          var panel = item.querySelector(".lv-acc__panel");
          var abierto = item.classList.contains("lv-abierto");
          if (unico) {
            acc.querySelectorAll(".lv-acc__item.lv-abierto").forEach(function (o) {
              if (o === item) return;
              o.classList.remove("lv-abierto");
              o.querySelector(".lv-acc__panel").style.height = "0px";
              o.querySelector(".lv-acc__btn").setAttribute("aria-expanded", "false");
            });
          }
          item.classList.toggle("lv-abierto", !abierto);
          btn.setAttribute("aria-expanded", String(!abierto));
          panel.style.height = abierto ? "0px" : panel.firstElementChild.offsetHeight + "px";
        });
      });
    });
  }

  /* ---------- Cifras animadas ---------- */
  function initCifras() {
    var nums = nuevos("[data-lv-contar]", "lvIniNum");
    if (!nums.length) return;
    if (sinMovimiento || !("IntersectionObserver" in window)) {
      nums.forEach(function (n) { n.textContent = n.getAttribute("data-lv-contar"); });
      return;
    }
    var obs = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (e) {
          if (!e.isIntersecting) return;
          obs.unobserve(e.target);
          var el = e.target;
          el.dataset.lvHecho = "1";
          var destino = parseFloat(el.getAttribute("data-lv-contar")) || 0;
          var dec = (el.getAttribute("data-lv-contar").split(".")[1] || "").length;
          var t0 = null;
          function paso(t) {
            if (!t0) t0 = t;
            var k = Math.min(1, (t - t0) / 1500);
            var s = 1 - Math.pow(1 - k, 4);
            el.textContent = (destino * s).toFixed(dec);
            if (k < 1) requestAnimationFrame(paso);
          }
          requestAnimationFrame(paso);
        });
      },
      { threshold: 0.5 }
    );
    nums.forEach(function (n) { n.textContent = "0"; obs.observe(n); });

    /* Misma red de seguridad que en los reveals: nunca dejar un "0" colgado. */
    setTimeout(function () {
      nums.forEach(function (n) {
        if (n.dataset.lvHecho) return;
        var caja = n.getBoundingClientRect();
        if (document.hidden || caja.top < (window.innerHeight || 800) * 1.2) {
          n.dataset.lvHecho = "1";
          n.textContent = n.getAttribute("data-lv-contar");
        }
      });
    }, 2600);
  }

  /* ---------- Galería del producto ---------- */
  function initGaleria() {
    var g = nuevos("[data-lv-galeria]", "lvIniGal")[0];
    if (!g) return;
    var principal = g.querySelector("[data-lv-principal]");
    var minis = g.querySelectorAll("[data-lv-mini]");
    if (!principal || !minis.length) return;
    minis.forEach(function (mini) {
      mini.addEventListener("click", function () {
        var src = mini.getAttribute("data-src");
        var alt = mini.getAttribute("data-alt") || "";
        if (!src) return;
        principal.style.opacity = "0";
        setTimeout(function () {
          principal.src = src;
          principal.alt = alt;
          principal.style.opacity = "1";
        }, 170);
        minis.forEach(function (m) { m.classList.remove("lv-on"); m.setAttribute("aria-current", "false"); });
        mini.classList.add("lv-on");
        mini.setAttribute("aria-current", "true");
      });
    });
  }

  /* ---------- Variantes del producto ---------- */
  function initVariantes() {
    var form = nuevos("[data-lv-form]", "lvIniVar")[0];
    if (!form) return;
    var datos = document.querySelector("[data-lv-variantes]");
    if (!datos) return;
    var variantes;
    try { variantes = JSON.parse(datos.textContent); } catch (e) { return; }
    var selects = form.querySelectorAll("[data-lv-opcion]");
    if (!selects.length) return;
    var input = form.querySelector('input[name="id"]');
    var boton = form.querySelector("[data-lv-add]");
    var precio = document.querySelector("[data-lv-precio]");
    var antes = document.querySelector("[data-lv-precio-antes]");
    var ahorro = document.querySelector("[data-lv-ahorro]");
    var textoBoton = boton ? boton.getAttribute("data-texto") : "";
    var textoAgotado = boton ? boton.getAttribute("data-agotado") : "";

    function dinero(centimos) {
      var f = window.Shopify && window.Shopify.money_format ? window.Shopify.money_format : "${{amount}}";
      var v = (centimos / 100).toFixed(2);
      var partes = v.split(".");
      partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return f
        .replace(/\{\{\s*amount\s*\}\}/, partes.join("."))
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, partes[0])
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace(".", ","));
    }

    function actualizar() {
      var elegidas = [];
      selects.forEach(function (s) { elegidas.push(s.value); });
      var v = variantes.filter(function (va) {
        return va.options.every(function (o, i) { return o === elegidas[i]; });
      })[0];
      if (!v) return;
      if (input) input.value = v.id;
      if (precio) precio.textContent = dinero(v.price);
      var enOferta = !!(v.compare_at_price && v.compare_at_price > v.price);
      if (antes) {
        if (enOferta) {
          antes.textContent = dinero(v.compare_at_price);
          antes.classList.remove("lv-hide");
        } else {
          antes.classList.add("lv-hide");
        }
      }
      if (ahorro) {
        if (enOferta) {
          var dif = v.compare_at_price - v.price;
          var pct = Math.round((dif * 100) / v.compare_at_price);
          ahorro.textContent = (ahorro.getAttribute("data-plantilla") || "Save {amount} · {percent}% off")
            .replace("{amount}", dinero(dif))
            .replace("{percent}", pct);
          ahorro.classList.remove("lv-hide");
        } else {
          ahorro.classList.add("lv-hide");
        }
      }
      if (boton) {
        boton.disabled = !v.available;
        var span = boton.querySelector("span");
        if (span) span.textContent = v.available ? textoBoton : textoAgotado;
      }
    }
    selects.forEach(function (s) { s.addEventListener("change", actualizar); });
    actualizar();
  }

  /* ---------- Judge.me: ocultar lo que aún está vacío ----------
     Mientras no haya ninguna reseña, el widget se queda en blanco y la
     valoración marca "No reviews". Ninguna de las dos cosas ayuda a vender,
     así que se ocultan solas y vuelven a aparecer con la primera reseña. */
  function initJudgeme() {
    var badge = nuevos(".lv-pro__valoracion--jm", "lvIniJm")[0];
    var widget = nuevos(".jdgm-review-widget", "lvIniJm")[0];
    var seccion = widget ? widget.closest('[id^="shopify-section"]') : null;
    if (!badge && !widget) return;

    function revisar() {
      if (badge) {
        var prev = badge.querySelector(".jdgm-prev-badge");
        var n = prev ? parseInt(prev.getAttribute("data-number-of-reviews"), 10) : 0;
        badge.style.display = prev && n > 0 ? "" : "none";
      }
      if (widget && seccion) {
        var vacio = widget.children.length === 0 || widget.offsetHeight < 10;
        seccion.style.display = vacio ? "none" : "";
      }
    }

    revisar();
    var obs = new MutationObserver(revisar);
    if (badge) obs.observe(badge, { childList: true, subtree: true, attributes: true });
    if (widget) obs.observe(widget, { childList: true, subtree: true });
    [600, 1800, 4000, 8000].forEach(function (t) { setTimeout(revisar, t); });
  }

  /* ---------- Selector de cantidad ---------- */
  function initCantidad() {
    nuevos("[data-lv-cantidad]", "lvIniCant").forEach(function (caja) {
      var input = caja.querySelector("[data-lv-cant-input]");
      if (!input) return;
      function refrescar() {
        var v = parseInt(input.value, 10);
        if (isNaN(v) || v < 1) v = 1;
        input.value = v;
        var menos = caja.querySelector('[data-lv-cant="-1"]');
        if (menos) menos.disabled = v <= 1;
      }
      caja.querySelectorAll("[data-lv-cant]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          var paso = parseInt(btn.getAttribute("data-lv-cant"), 10) || 0;
          input.value = (parseInt(input.value, 10) || 1) + paso;
          refrescar();
        });
      });
      input.addEventListener("change", refrescar);
      refrescar();
    });
  }

  /* ---------- Barra de compra pegajosa ---------- */
  function initBarraCompra() {
    var barra = nuevos("[data-lv-barra]", "lvIniBar")[0];
    var ancla = document.querySelector("[data-lv-ancla]");
    if (!barra || !ancla) return;
    if (!("IntersectionObserver" in window)) return;
    var obs = new IntersectionObserver(
      function (en) {
        en.forEach(function (e) { barra.classList.toggle("lv-barra--on", !e.isIntersecting && e.boundingClientRect.top < 0); });
      },
      { threshold: 0 }
    );
    obs.observe(ancla);
    var btn = barra.querySelector("[data-lv-barra-add]");
    if (btn) {
      btn.addEventListener("click", function () {
        var real = document.querySelector("[data-lv-add]");
        if (real) real.click();
      });
    }
  }

  function arrancar() {
    initReveals();
    initParallax();
    initComparador();
    initSticky();
    initAcordeon();
    initCifras();
    initGaleria();
    initVariantes();
    initCantidad();
    initJudgeme();
    initBarraCompra();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", arrancar);
  } else {
    arrancar();
  }

  /* El editor de Shopify recarga secciones sueltas: re-arrancamos */
  document.addEventListener("shopify:section:load", arrancar);
})();
